var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "columns is-gapless" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field has-addons" }, [
            _c(
              "div",
              { staticClass: "control has-icons-left has-icons-right" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.query,
                      expression: "filter.query",
                    },
                  ],
                  staticClass: "input",
                  attrs: {
                    type: "text",
                    placeholder: "Start typing to filter",
                  },
                  domProps: { value: _vm.filter.query },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.filter, "query", $event.target.value)
                      },
                      _vm.search,
                    ],
                  },
                }),
                _vm._m(0),
              ]
            ),
            _c("div", { staticClass: "control" }, [
              _c(
                "a",
                {
                  staticClass: "button is-primary is-outlined tooltip",
                  attrs: { "data-tooltip": "Reset search" },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._m(1)]
              ),
            ]),
          ]),
        ]),
        _vm.showScrollOnAdd
          ? _c(
              "div",
              {
                staticClass: "column is-narrow",
                staticStyle: { display: "flex", "align-items": "center" },
              },
              [
                _c("div", { staticClass: "field-body" }, [
                  _c("div", { staticClass: "field is-narrow" }, [
                    _c("input", {
                      staticClass: "is-checkradio",
                      attrs: {
                        id: "labourScroll",
                        type: "checkbox",
                        name: "labourScroll",
                      },
                      domProps: { checked: _vm.$userInfo.scrollItemLabour },
                      on: { change: _vm.$setScrollItemLabour },
                    }),
                    _c("label", { attrs: { for: "labourScroll" } }, [
                      _vm._v("Scroll on add"),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "column is-narrow" }, [
          _c("div", { staticClass: "field is-horizontal is-pulled-right" }, [
            _c("div", { staticClass: "field-body" }, [
              _vm.selectedTimeType ===
              _vm.labourTimeTypes.RACQ.replace("-", "").toLowerCase()
                ? _c("div", { staticClass: "field is-narrow" }, [
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedRacqBodySize,
                                expression: "selectedRacqBodySize",
                              },
                            ],
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedRacqBodySize = $event.target
                                    .multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.getAvailableLabours()
                                },
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "A" } }, [
                              _vm._v("A Size"),
                            ]),
                            _c("option", { attrs: { value: "B" } }, [
                              _vm._v("B Size"),
                            ]),
                            _c("option", { attrs: { value: "W" } }, [
                              _vm._v("Wagon"),
                            ]),
                            _c("option", { attrs: { value: "4" } }, [
                              _vm._v("4x4"),
                            ]),
                            _c("option", { attrs: { value: "V" } }, [
                              _vm._v("Van"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm.selectedTimeType ===
              _vm.labourTimeTypes.WESF.replace("-", "").toLowerCase()
                ? _c("div", { staticClass: "field is-narrow" }, [
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedWesfBodySize,
                                expression: "selectedWesfBodySize",
                              },
                            ],
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedWesfBodySize = $event.target
                                    .multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.getAvailableLabours()
                                },
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "Medium" } }, [
                              _vm._v("Medium"),
                            ]),
                            _c("option", { attrs: { value: "Large" } }, [
                              _vm._v("Large"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "field is-narrow" }, [
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "select" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedTimeType,
                            expression: "selectedTimeType",
                          },
                        ],
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedTimeType = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.getAvailableLabours()
                            },
                          ],
                        },
                      },
                      _vm._l(
                        _vm.labourTimeTypes,
                        function (labourTime, propertyName, index) {
                          return _c(
                            "option",
                            {
                              key: index,
                              domProps: {
                                value: labourTime
                                  .replace("-", "")
                                  .toLowerCase(),
                              },
                            },
                            [_vm._v(" " + _vm._s(labourTime) + " ")]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _vm.selectedTimeType ===
              _vm.labourTimeTypes.eMTA.replace("-", "").toLowerCase()
                ? _c("div", { staticClass: "field is-narrow" }, [
                    _c("div", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button tooltip is-tooltip-topright",
                          attrs: { "data-tooltip": "Change e-MTA vehicle" },
                          on: { click: _vm.emtaTest },
                        },
                        [_vm._m(2)]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table-container-avaialble-butterfly-items" },
        [
          _c(
            "bulma-table",
            {
              staticClass: "table is-striped is-narrow is-fullwidth",
              attrs: {
                columns: _vm.columns,
                "has-sticky-header": true,
                "page-index": _vm.filter.pageIndex,
                "page-size": _vm.filter.pageSize,
                "total-rows": _vm.totalRows,
                "is-loading": _vm.isTableLoading,
                "sort-column": _vm.filter.sortColumn,
                "sort-order": _vm.filter.sortOrder,
              },
              on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
            },
            [
              _vm._l(_vm.availableItems, function (item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item.itemNo))]),
                  _c(
                    "td",
                    {
                      on: {
                        dblclick: function ($event) {
                          return _vm.addNewItems(item, index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.description))]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "has-text-right",
                      on: {
                        click: function ($event) {
                          return _vm.addSingleNewItem(
                            item,
                            _vm.itemCategoryTypes.RR,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "butterfly-item-values is-flex is-justify-content-center",
                          class: [
                            {
                              "has-text-weight-bold is-selected": _vm.findItem(
                                item,
                                _vm.itemCategoryTypes.RR
                              ),
                            },
                            {
                              "is-zero-unselected":
                                _vm.getDisplayValue(
                                  _vm.itemCategoryTypes.RR,
                                  item.rrHour
                                ) === 0 &&
                                !_vm.findItem(item, _vm.itemCategoryTypes.RR),
                            },
                          ],
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.getDisplayValue(
                                    _vm.itemCategoryTypes.RR,
                                    item.rrHour
                                  ),
                                  _vm.$userInfo.locale
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "has-text-right",
                      on: {
                        click: function ($event) {
                          return _vm.addSingleNewItem(
                            item,
                            _vm.itemCategoryTypes.REP,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "butterfly-item-values is-flex is-justify-content-center",
                          class: [
                            {
                              "has-text-weight-bold is-selected": _vm.findItem(
                                item,
                                _vm.itemCategoryTypes.REP
                              ),
                            },
                            {
                              "is-zero-unselected":
                                _vm.getDisplayValue(
                                  _vm.itemCategoryTypes.REP,
                                  item.repairHour
                                ) === 0 &&
                                !_vm.findItem(item, _vm.itemCategoryTypes.REP),
                            },
                          ],
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.getDisplayValue(
                                    _vm.itemCategoryTypes.REP,
                                    item.repairHour
                                  ),
                                  _vm.$userInfo.locale
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "has-text-right",
                      on: {
                        click: function ($event) {
                          return _vm.addSingleNewItem(
                            item,
                            _vm.itemCategoryTypes.PAINT,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "butterfly-item-values is-flex is-justify-content-center",
                          class: [
                            {
                              "has-text-weight-bold is-selected": _vm.findItem(
                                item,
                                _vm.itemCategoryTypes.PAINT
                              ),
                            },
                            {
                              "is-zero-unselected":
                                _vm.getDisplayValue(
                                  _vm.itemCategoryTypes.PAINT,
                                  item.paintHour
                                ) === 0 &&
                                !_vm.findItem(
                                  item,
                                  _vm.itemCategoryTypes.PAINT
                                ),
                            },
                          ],
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.getDisplayValue(
                                    _vm.itemCategoryTypes.PAINT,
                                    item.paintHour
                                  ),
                                  _vm.$userInfo.locale
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              }),
              _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "section" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c("span", { attrs: { icon: "icon is-large" } }, [
                        _c("i", {
                          staticClass: "mdi mdi-48px mdi-emoticon-sad",
                        }),
                      ]),
                      _c("p", [_vm._v("Nothing")]),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.isButterflyModalActive
            ? _c(
                "butterfly-modal",
                {
                  attrs: { active: _vm.isButterflyModalActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.isButterflyModalActive = $event
                    },
                    filterButterfly: _vm.butterflySearch,
                    reset: _vm.reset,
                    done: _vm.filterButterly,
                    cancel: _vm.cancel,
                  },
                  model: {
                    value: _vm.selectedButterflyCodes,
                    callback: function ($$v) {
                      _vm.selectedButterflyCodes = $$v
                    },
                    expression: "selectedButterflyCodes",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "text-content" }, slot: "text-content" },
                    [
                      _vm.isButterflyModalActive
                        ? _c("butterfly", {
                            model: {
                              value: _vm.selectedButterflyCodes,
                              callback: function ($$v) {
                                _vm.selectedButterflyCodes = $$v
                              },
                              expression: "selectedButterflyCodes",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.isEmtaRegistrationModalActive
        ? _c("emta-registration-modal", {
            attrs: {
              active: _vm.isEmtaRegistrationModalActive,
              "icon-name": "mdi-account-plus",
              "icon-type": "primary",
            },
            on: {
              "update:active": function ($event) {
                _vm.isEmtaRegistrationModalActive = $event
              },
              register: _vm.registerEmta,
              cancel: _vm.cancelEmta,
            },
          })
        : _vm._e(),
      _vm.isEmtaVehicleSelectionModalActive
        ? _c("emta-vehicle-selection-modal", {
            attrs: {
              active: _vm.isEmtaVehicleSelectionModalActive,
              "icon-name": "mdi-car",
              "icon-type": "primary",
              make: _vm.make,
              model: _vm.model,
              year: _vm.year,
            },
            on: {
              "update:active": function ($event) {
                _vm.isEmtaVehicleSelectionModalActive = $event
              },
              select: _vm.selectEmtaVehicle,
              cancel: _vm.cancelEmtaVehicle,
            },
            model: {
              value: _vm.emtaVehicle,
              callback: function ($$v) {
                _vm.emtaVehicle = $$v
              },
              expression: "emtaVehicle",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-car" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }